import React from "react";
import "../assets/css/footer.css";

function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-content">
        <h4>Home of Electric</h4>
      </div>
      <div className="footer-bottom">
        <p>Copyright &copy; 2023 Home of Electric. Designed by Erson Bytyqi</p>
      </div>
    </div>
  );
}

export default Footer;
